module.exports = __webpack_public_path__ + "static/media/biol.9ec676a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/biol.png
// module id = 120
// module chunks = 0